import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_MEM_34 } from "@/lib/programData";

export default function MarrakechLoop34Page() {
  return <ProgramTemplate program={PROGRAM_MEM_34} variant="mem" showJourneyChronology />;
}
